module.exports = __webpack_public_path__ + "img/benefit_1.1406090e.svg";